import { useEffect } from "react";
import Center from "./Center";
import MobileCenter from "./mobile/MobileCenter";
import { useIsMobile } from "./shared";
import context from "./Administration/context/shared";
import { AuthStates, useAuth } from "blick.react.utils";
import { router } from "../router";
import { setBackExitWarning, confirmBackExit } from "../utils/backButton";
import { confirm } from "../utils/confirm";
import { ConfirmDialogProps } from "../utils/ConfirmDialog";
import 'blick.react.aggrid/css/ag-theme-alpine.custom.less';

const Layout = () => {
    const auth = useAuth(router);

    useEffect(() => {
        if (auth.status != AuthStates.Authenticated)
            return;
        context.loadDeviceModels();
        // системная «Назад» на корневом экране: предупреждение перед выходом из приложения
        setBackExitWarning(() => {
            confirm(new ConfirmDialogProps('Покинуть приложение?'))
                .then(ok => {
                    if (ok)
                        confirmBackExit();
                });
        });
        return () => setBackExitWarning(null);
    }, [auth.status])
    const isMobile = useIsMobile();

    return (
        auth.status == AuthStates.Authenticated ?
            isMobile ? <MobileCenter/> : <Center/> : <></>
    );   
}
export default Layout;
